import { render } from "./MyPagesOrders.vue?vue&type=template&id=2b161adc"
import script from "./MyPagesOrders.vue?vue&type=script&lang=js"
export * from "./MyPagesOrders.vue?vue&type=script&lang=js"

import "./MyPagesOrders.vue?vue&type=style&index=0&id=2b161adc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__